import React, { useContext, useState, useEffect, useRef } from "react";
import { ListGroup, Dropdown, Media, Button, Modal } from "react-bootstrap";
import { Link, useHistory, useLocation, useRouteMatch } from "react-router-dom";
import Avatar from "@mui/material/Avatar";
import PerfectScrollbar from "react-perfect-scrollbar";
import { ToastProvider, useToasts } from "react-toast-notifications";
import { Alert } from "react-bootstrap";
import ChatList from "./ChatList";
import PatientQueueFloatingMenu from "./PatientQueueFloatingMenu";
import { AudioAnalyzerFloatingMenu } from "../../../../views/patient/Evaluation/AuditoAnalyzer";
import { ConfigContext } from "../../../../contexts/ConfigContext";
import * as actionType from "../../../../store/actions";
import useAuth from "hooks/useAuth";
import { WebSocketContext } from "contexts/WebSocketProvider";
import avatar1 from "../../../../assets/images/user/avatar-1.jpg";
import avatar2 from "../../../../assets/images/user/avatar-2.jpg";
import avatar3 from "../../../../assets/images/user/avatar-3.jpg";
import avatar4 from "../../../../assets/images/user/avatar-4.jpg";
import fallbackImage from "assets/images/user/doctor-male-64.png";
import httpClient, { getBaseURL } from "utility/httpClient.util";
import objectPath from "object-path";
import FeatherIcon from "feather-icons-react";
import { Apps } from "@mui/icons-material";
import { stringAvatar } from "utility/common.util";
import { timeAgo } from "utility/common.util";
import { useTranslation } from "react-i18next";
import DOMPurify from "dompurify";
import moment from "dayjs";

import "./nav-right.scss";

const FLOATING_MENU_CONFIG_CODE = "floating_menu_config";

const normalizeFloatingMenuConfig = (floatingMenuConfig) => {
  if (typeof floatingMenuConfig !== "string") return floatingMenuConfig || {};
  try {
    return JSON.parse(floatingMenuConfig) || {};
  } catch (error) {
    return {};
  }
};

const getFloatingMenuRouteAllowPath = (floatingMenuConfig = {}, menuKey) => {
  const allowRoutePath = floatingMenuConfig?.[menuKey]?.allowRoutePath;
  if (Array.isArray(allowRoutePath)) {
    return allowRoutePath.map((route) => String(route).trim()).filter(Boolean);
  }
  if (typeof allowRoutePath === "string") {
    return allowRoutePath
      .split(/[\n,]+/)
      .map((route) => route.trim())
      .filter(Boolean);
  }
  return [];
};

const isAllowRoute = (pathname, routeAllowPath = []) => {
  return routeAllowPath.some(
    (route) => pathname === route || pathname.startsWith(`${route}/`)
  );
};

const getWebSubscriptionKey = (subscription = {}) => {
  const room = subscription?.eventData?.room;
  const event = subscription?.eventData?.event;

  return room && event ? `${room}::${event}` : "";
};

const normalizeWebSubscriptionList = (subscriptionList = []) => {
  const keySet = new Set();

  return subscriptionList.filter((subscription) => {
    const key = getWebSubscriptionKey(subscription);
    if (!key || keySet.has(key)) return false;

    keySet.add(key);
    return true;
  });
};

const roomList = [
  { name: "All Views", isActive: true, description: "", noOfPerson: 2 },
  { name: "OPD", isActive: false, description: "", noOfPerson: 2 },
  { name: "IPD", isActive: false, description: "", noOfPerson: 12 },
  { name: "Dental", isActive: false, description: "", noOfPerson: 2 },
  { name: "Screening", isActive: false, description: "", noOfPerson: 2 },
  { name: "Finance", isActive: false, description: "", noOfPerson: 2 },
  { name: "Pharmacy", isActive: false, description: "", noOfPerson: 2 },
  { name: "Social work", isActive: false, description: "", noOfPerson: 2 },
  { name: "ER", isActive: false, description: "Emergency Room", noOfPerson: 2 },
];

const AlertMessage = (props) => {
  const {
    variant,
    children,
    onDismiss,
    title,
    buttonName,
    buttonLink,
    actions,
  } = props;
  let history = useHistory();

  //console.log('p',props)
  const heading = title ? title : "Information";
  return (
    <Alert
      variant={variant}
      dismissible={false}
      onClose={onDismiss}
      className="alert-toast"
    >
      <Alert.Heading>{heading}</Alert.Heading>
      {children}
      {buttonName && !actions && (
        <React.Fragment>
          <hr />
          <div className="d-flex justify-content-end">
            <Button
              onClick={() => {
                if (buttonLink) history.push(buttonLink);

                if (onDismiss) {
                  onDismiss();
                }
              }}
              variant="primary"
            >
              {buttonName}
            </Button>
          </div>
        </React.Fragment>
      )}
      {actions && actions.length > 0 && (
        <React.Fragment>
          <hr />
          <div className="d-flex justify-content-end">
            {actions.map((action, index) => (
              <Button
                key={index}
                onClick={() => {
                  if (action?.link) history.push(action.link);

                  if (onDismiss) {
                    onDismiss();
                  }
                }}
                variant="primary"
              >
                {action.label}
              </Button>
            ))}
          </div>
        </React.Fragment>
      )}
    </Alert>
  );
};

const NotificationToast = () => {
  const {
    connected,
    currentChannel,
    socket,
    enableDebugLog,
    subscribe,
    unsubscribe,
    bindBroadcast,
    unbindBroadcast,
    broadcastMessage,
    pushMessage,
  } = useContext(WebSocketContext);
  const { addToast, removeToast } = useToasts();
  useEffect(() => {
    //loadPusher()
    if (socket && socket.connect) loadBcSocket();
  }, [socket]);

  const renderContent = (toastId, data) => {
    const content = data.message ? data.message : data;
    return (
      <AlertMessage
        {...data}
        onDismiss={() => {
          removeToast(toastId, () => {
            // console.log("ok remove", toastId);
          });
        }}
      >
        {content}
      </AlertMessage>
    );
  };

  const renderContentk = (toastId, data, content) => {
    return (
      <div>
        {" "}
        <h1>{content}</h1>{" "}
      </div>
    );
  };

  const loadBcSocket = () => {
    const eventBCList = ["success", "error", "warning", "info"];
    eventBCList.forEach((eventName) => {
      bindBroadcast(eventName, (event) => {
        //Notification
        const toastId = new Date().getTime();
        // console.log("toastId",toastId)

        const appearance =
          eventName && eventBCList.includes(eventName) ? eventName : "info";

        addToast(renderContent(toastId, event.data), {
          id: toastId,
          appearance: appearance,
          autoDismiss: false,
          onDismiss: () => {
            // console.log("onDis");
          },
        });
      });
    });
  };

  return <React.Fragment></React.Fragment>;
};

const NotificationSubscribeToast = ({ webSubscription }) => {
  const joinedSubscriptionRef = useRef(new Set());
  const {
    connected,
    currentChannel,
    socket,
    enableDebugLog,
    subscribe,
    unsubscribe,
    bindBroadcast,
    unbindBroadcast,
    broadcastMessage,
    pushMessage,
  } = useContext(WebSocketContext);
  const { addToast, removeToast } = useToasts();
  const { config, getConfig, getJsonConfig } = useAuth();
  useEffect(() => {
    //loadPusher()
    if (socket && socket.connect) {
    }
  }, [socket]);

  useEffect(() => {
    if (!socket || !socket.connect || !webSubscription) return;

    normalizeWebSubscriptionList(webSubscription).forEach((sub) => {
      const subscriptionKey = getWebSubscriptionKey(sub);
      if (joinedSubscriptionRef.current.has(subscriptionKey)) return;

      joinedSubscriptionRef.current.add(subscriptionKey);
      joinChannel(sub.eventData?.room, sub.eventData?.event);
    });
  }, [socket, webSubscription]);

  const audioCache = {};
  const playAlertSound = async (appearance) => {
    const playSound = getJsonConfig("notification_play_sound");
    if (playSound) {
      // 1️⃣ Find sound source — prioritize appearance sound, fallback to default
      let sourceUrl =
        playSound?.[appearance]?.sourceUrl || playSound?.sourceUrl;
      if (!sourceUrl) return; // No valid source, stop early

      // 2️⃣ Determine loop count
      const loopCount =
        playSound?.[appearance]?.loopCount ?? playSound?.loopCount ?? 3;

      // 3️⃣ Function to play once
      const playOnce = (url) => {
        if (!audioCache[url]) {
          audioCache[url] = new Audio(url);
        }
        const audio = audioCache[url];
        return audio
          .play()
          .catch((err) => console.warn("Audio play failed:", err));
      };

      // 4️⃣ Play multiple times with delay
      for (let i = 0; i < loopCount; i++) {
        await playOnce(sourceUrl);
        await new Promise((resolve) => setTimeout(resolve, 500)); // 0.5s gap
      }
    }
  };

  const joinChannel = (channelCode, eventCode) => {
    if (!channelCode || !eventCode) return;

    const channel = subscribe(channelCode);
    channel.bind(eventCode, (event) => {
      console.log("join channel debug changed", event);
      // setEvent(event)
      const { data } = event;
      const appearance = ["success", "error", "info", "warning"].includes(
        event.data?.appearance
      )
        ? event.data.appearance
        : "info";
      const content = data.message ? data.message : ('New Update : '+eventCode);
      const toastId = new Date().getTime();
      playAlertSound(appearance);
      addToast(
        <AlertMessage
          toastId={toastId}
          {...event.data}
          removeToast={removeToast}
        >
          {content}
        </AlertMessage>,
        {
          id: toastId,
          appearance: appearance,
          autoDismiss: false,
          onDismiss: () => {
            console.log("onDis");
          },
        }
      );
    });
  };

  const renderContent = (toastId, data) => {
    const content = data.message ? data.message : data;
    return (
      <AlertMessage
        {...data}
        onDismiss={() => {
          removeToast(toastId, () => {
            // console.log("ok remove", toastId);
          });
        }}
      >
        {content}
      </AlertMessage>
    );
  };

  const renderContentk = (toastId, data, content) => {
    return (
      <div>
        {" "}
        <h1>{content}</h1>{" "}
      </div>
    );
  };

  return <React.Fragment></React.Fragment>;
};

const NavRight = () => {
  const { perspective, config, logout, user, getJsonConfig } = useAuth();
  const configContext = useContext(ConfigContext);
  const history = useHistory();
  const location = useLocation();
  const pathname = location.pathname;
  const match = useRouteMatch(pathname);
  const matchUrl = match.url;
  const { i18n } = useTranslation();
  const { rtlLayout, collapseMenu } = configContext.state;

  const [listOpen, setListOpen] = useState(false);
  const [userMenu, setUserMenu] = useState([]);
  const [notification, setNotification] = useState([]);
  const [webSubscription, setWebSubsuscription] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [summaryNotification,setSummaryNotification] = useState({total:0,perPage:5,page:1,totalPage:0})
  const [showNotification, setShowNotification] = useState(false);
  const [showNotificationModal,setShowNotificationModal] = useState(false)
  const [showApp, setShowApp] = useState(false);
  const [feedList, setFeedList] = useState([]);
  const [showFeedModal, setShowFeedModal] = useState(false);
  const [showBadge, setShowBadge] = useState({
    notification: true,
    online: false,
    task: false,
  });
  const queryParams = new URLSearchParams(history.location.search);
  const floatingMenuConfig = normalizeFloatingMenuConfig(
    getJsonConfig(FLOATING_MENU_CONFIG_CODE)
  );
  const audioAnalyzerRouteAllowPath = getFloatingMenuRouteAllowPath(
    floatingMenuConfig,
    "audioAnalyzer"
  );
  const patientQueueRouteAllowPath = getFloatingMenuRouteAllowPath(
    floatingMenuConfig,
    "patientQueue"
  );
  const showAudioAnalyzerFloatingMenu = isAllowRoute(
    pathname,
    audioAnalyzerRouteAllowPath
  );
  const showPatientQueueFloatingMenu = isAllowRoute(
    pathname,
    patientQueueRouteAllowPath
  );

  const toggleDropdown = (event) => {
    event.preventDefault();
    setShowDropdown(!showDropdown);
  };

  const toggleNotification = (event) => {
    event.preventDefault();
    setShowNotification(!showNotification);
  };

  const toggleApp = (event) => {
    event.preventDefault();
    setShowApp(!showApp);
  };

  //console.log('user', user)

  useEffect(() => {
    //debugger
    const userLanguage = localStorage.getItem("userLanguage") || null;
    if (userLanguage) i18n.changeLanguage(userLanguage);
  }, [i18n]);

  useEffect(async () => {
    let find = perspective?.find((item) => item.routePath === `/users`);
    if (!find) {
      let response = await getPerspective();
      find = response?.find((item) => item.routePath === `/users`);
    }
    if (find) {
      //debugger
      const userMenuList = await getUserMenu(find.perspectiveId);
      let menuList = userMenuList.reduce((result, { pageMenuDesign = {} }) => {
        let menuType = pageMenuDesign.menuType;
        if (menuType !== "item") return result;
        let { path, title } = pageMenuDesign.data;
        let icon = "";
        let iconSource =
          objectPath.get(pageMenuDesign, "data.iconSource") || "";
        let iconName = objectPath.get(pageMenuDesign, "data.icon") || "";
        let iconText = objectPath.get(pageMenuDesign, "data.iconText") || "";
        let iconType = objectPath.get(pageMenuDesign, "data.iconType") || "";
        let iconColor = objectPath.get(pageMenuDesign, "data.iconColor") || "";
        let iconTextColor =
          objectPath.get(pageMenuDesign, "data.iconTextColor") || "";

        if (iconType === "char") {
          icon = `ck-badge badge-primary`;
        } else {
          icon = iconName;
        }
        result.push({
          path: path,
          icon: icon,
          iconSource: iconSource,
          iconName: iconName,
          iconText: iconText,
          iconType: iconType,
          iconColor: iconColor,
          iconTextColor: iconTextColor,
          title: title,
        });
        return result;
      }, []);
      console.log("menuList", menuList);
      setUserMenu(menuList);
    } else {
      setUserMenu([]);
    }

    return () => {
      setUserMenu([]);
    };
  }, [perspective, config]);

  useEffect(async () => {
    if (user) {
      await checkNotification(user);
    }
  }, [user]);

  const checkNotification = async (user) => {
    try {
      //console.log('position', user)
      const employeePositionId = user?.employeeJob?.employeePositionId || 0;
      const today = moment().format("YYYY-MM-DD");

      const feedStorage = JSON.parse(
        localStorage.getItem("notification-alert") 
      ) || {feed:{date:null},notification:{date:null}};

      if (true || (feedStorage && feedStorage?.feed?.date === today)) {
        let subscriberRef = "";
        const find = config.find(
          ({ configCode }) => configCode === "menu_visible"
        );
        if (find) {
          find.jsonData.permissions.forEach((permission) => {
            subscriberRef = permission?.code;
          });
        }
        const rNotf = await httpClient.get(
          `/workspace/notification-subscription/me?subscriberType=GROUP&channelCode=WEBSOCKET&subscriberRef=${subscriberRef}&perPage=${summaryNotification?.perPage||5}`
        );
        const notfList = rNotf?.data?.data || []
        setNotification(notfList);
        setSummaryNotification(rNotf?.data?.pagination)

        //Check this is first time notification of the day

        //Then Subscription web-socket

        //Subscribe user
        const sub = (rNotf?.data?.aggregate?.subscription || []).concat([
          {
            eventData: {
              room: "user-" + user?.ckdUserId,
              event: "user-message",
            },
          },
        ]);

        setWebSubsuscription(sub);
        if (notfList && notfList.length > 0 && (feedStorage && feedStorage?.notification?.date !== today)) {
          setShowNotificationModal(true);
        }
      } else {
        const [all, position, rNotf] = await Promise.all([
          httpClient.get(
            `/workspace/feed-notification?filterDate=${today}&isAlertEveryDay=1&positionIdIsNull=true&include=feed.createdByUser`
          ),
          httpClient.get(
            `/workspace/feed-notification?filterDate=${today}&isAlertEveryDay=1&employeePositionId=${employeePositionId}&include=feed.createdByUser`
          ),
          httpClient.get(`/workspace/notification/me?include=user,user.prefix`),
        ]);

        const feedList = [].concat(all.data.data).concat(position.data.data);
        //Post Token

        //debugger
        if (all && position) {
        }
        setFeedList(feedList);
        setNotification(rNotf.data.data);
        if (feedList && feedList.length > 0) {
          setShowFeedModal(true);
        }
      }
    } catch (ex) {
      //No Problem
      console.log("Exception", ex);
    }
  };

  const filterMenuByPermission = (allMenus) => {
    const find = config.find(({ configCode }) => configCode === "menu_visible");
    //console.log('getPer',find)
    // Create a Set of perspective IDs

    const newAllowList = [];
    if (find) {
      allMenus.forEach((item) => {
        find.jsonData.permissions.forEach((permission) => {
          permission.perspective.forEach((perspective) => {
            if (perspective.pathsId.includes(item.pageMenuDesignId)) {
              newAllowList.push(item);
            }
          });
        });
      });
    }
    let userPermissions = user.permissions || [];
    if (userPermissions.includes("role:ckdoctor:admin")) {
      //newAllowList = allMenus;
    }
    return newAllowList;
  };

  const getPerspective = async () => {
    let api = `/designer/perspective`;
    let response = await httpClient
      .get(api)
      .then(({ data }) => data.data)
      .catch(() => []);
    return response;
  };

  const getPerspectiveById = async (perspectiveId) => {
    let api = `/designer/perspective-menu-collection/getByPerspective?perspectiveId=${perspectiveId}`;
    let response = await httpClient
      .get(api)
      .then(({ data }) => data.data)
      .catch(() => []);
    return response;
  };

  const getUserMenu = async (perspectiveId) => {
    let response = await getPerspectiveById(perspectiveId);
    response = response.sort((a, b) => a.seq - b.seq);
    return filterMenuByPermission(response);
  };

  const onClickMenu = async (event,path)=>{
    toggleDropdown(event)
    history.push(path);   // then navigate
  }

  const handleLogout = async (event = null) => {
    if (event) event.preventDefault();

    try {
      //handleClose();
      broadcastMessageLogout({
        type: "logout",
        isLogOut: false,
        tabId: user?.tabId,
      });
      await logout();
    } catch (err) {
      console.error(err);
    }
  };

  const broadcastMessageLogout = (message) => {
    const channel = new BroadcastChannel("user-profile-bc");
    channel.postMessage(message);
    channel.close();
  };

  const onClickAppItem = (newValue) => {
    let matchList = matchUrl.split("/");
    let routePath = newValue?.routePath || "";
    let routePathList = routePath.split("/");
    routePathList.forEach((item, index) => {
      matchList[index] = item;
    });
    let historyData = {
      pathname: matchList.join("/"),
      search: history.location.search,
    };
    history.push(historyData);
  };

  const onDeleteAll = async () => {
    try {
      await httpClient.delete(`/workspace/notification/me?isRead=0`, {
        isRead: 1,
      });
      //Show Notification on The Right
      setNotification([]);
    } catch (e) {}
  };

  const onMarkAsReadAll = async () => {
    try {
      await httpClient.put(`/workspace/notification/me?isRead=0`, {
        isRead: 1,
      });
      //Show Notification on The Right
      setNotification(
        [].concat(
          notification.map((item) => {
            item.isRead = 1;

            return item;
          })
        )
      );
    } catch (e) {}
  };

  const onAckClick = () => {
    const feedStorage = JSON.parse(
        localStorage.getItem("notification-alert") 
      ) || {feed:{date:null},notification:{date:null}};    
    const today = moment().format("YYYY-MM-DD");
    feedStorage.feed.date = today
    localStorage.setItem(
      "notification-alert",
      JSON.stringify(feedStorage)
    );

    setShowFeedModal(false);
  };

  const onViewNotification = ()=>{

    history.push('/users/notification')
    setShowNotificationModal(false)
  }

  const openTaskBoard = (event) => {
    event.preventDefault();

    if (collapseMenu) {
      configContext.dispatch({ type: actionType.COLLAPSE_MENU });
    }

    configContext.dispatch({
      type: actionType.GROUP_MENU_ID,
      groupMenuId: "user",
    });
    configContext.dispatch({
      type: actionType.MENU_CLICK,
      menuClick: {
        id: "user-task",
        groupMenuId: "user",
        url: "/users/task-board",
      },
    });

    history.push("/users/task-board");
  };

  const onAckNotificationClick = () => {
    const feedStorage = JSON.parse(
        localStorage.getItem("notification-alert") 
      ) || {feed:{date:null},notification:{date:null}};
    const today = moment().format("YYYY-MM-DD");
    feedStorage.notification.date = today
    localStorage.setItem(
      "notification-alert",
      JSON.stringify(feedStorage)
    );

    setShowNotificationModal(false);

  };  

  const renderAvailableApp = () => {
    return (
      <ListGroup.Item as="li" bsPrefix=" ">
        <Dropdown
          alignRight={!rtlLayout}
          show={showApp}
          onToggle={() => setShowApp(!showApp)}
        >
          <Dropdown.Toggle
            as={Link}
            variant="link"
            to="#"
            id="dropdown-basic"
            onClick={toggleApp}
          >
            <Apps />
          </Dropdown.Toggle>
          <Dropdown.Menu
            alignRight
            className="notification notification-scroll"
            style={{ width: "220px" }}
          >
            <div className="noti-head">
              <h6 className="d-inline-block m-b-0">
                <Apps /> Switch to
              </h6>
            </div>
            <PerfectScrollbar>
              <ListGroup
                as="ul"
                bsPrefix=" "
                variant="flush"
                className="noti-body noti-room"
              >
                <ListGroup.Item as="li" bsPrefix=" " className="n-title">
                  <p className="m-b-0">Available Apps</p>
                </ListGroup.Item>
                {perspective
                  .slice() // Create a copy to avoid mutating the original array
                  .filter(({ visibleOnParams }) => {
                    // If visibleOnParams is null or an empty array, it passes
                    if (!visibleOnParams || visibleOnParams.length === 0)
                      return true;

                    // Otherwise, check if queryParams contains any of the visibleOnParams
                    return visibleOnParams.every((param) =>
                      queryParams.get(param)
                    );
                  })
                  .sort((a, b) => a.name.localeCompare(b.name)) // Sort by option.name
                  .map((item, index) => (
                    <ListGroup.Item
                      as="li"
                      key={index}
                      bsPrefix=" "
                      className="notification "
                      style={{ padding: "10px 15px", cursor: "pointer" }}
                      onClick={() => onClickAppItem(item)}
                    >
                      <Media>
                        <Avatar
                          {...stringAvatar(
                            item.name,
                            { background: item.bgColor || "inherit" },
                            1
                          )}
                          className="avatar"
                        />
                        <Media.Body>
                          <p>
                            <strong>{item.name}</strong>
                          </p>
                          <p>{item.routePath}</p>
                        </Media.Body>
                      </Media>
                    </ListGroup.Item>
                  ))}
              </ListGroup>
            </PerfectScrollbar>
          </Dropdown.Menu>
        </Dropdown>
      </ListGroup.Item>
    );
  };

  const dummyItem = () => {
    return (
      <>
        <ListGroup.Item as="li" bsPrefix=" " className="notification">
          <Media>
            <img
              className="img-radius"
              src={avatar2}
              alt="Generic placeholder"
            />
            <Media.Body>
              <p>
                <strong>Joseph William</strong>
                <span className="n-time text-muted">
                  <i className="icon feather icon-clock m-r-10" />
                  30 min
                </span>
              </p>
              <p>Purchase New Theme and make payment</p>
            </Media.Body>
          </Media>
        </ListGroup.Item>
        <ListGroup.Item as="li" bsPrefix=" " className="notification">
          <Media>
            <img
              className="img-radius"
              src={avatar3}
              alt="Generic placeholder"
            />
            <Media.Body>
              <p>
                <strong>Sara Soudein</strong>
                <span className="n-time text-muted">
                  <i className="icon feather icon-clock m-r-10" />
                  30 min
                </span>
              </p>
              <p>currently login</p>
            </Media.Body>
          </Media>
        </ListGroup.Item>
        <ListGroup.Item as="li" bsPrefix=" " className="notification">
          <Media>
            <img
              className="img-radius"
              src={avatar4}
              alt="Generic placeholder"
            />
            <Media.Body>
              <p>
                <strong>Suzen</strong>
                <span className="n-time text-muted">
                  <i className="icon feather icon-clock m-r-10" />
                  yesterday
                </span>
              </p>
              <p>Purchase New Theme and make payment</p>
            </Media.Body>
          </Media>
        </ListGroup.Item>
      </>
    );
  };

  const renderNotification = () => {
    return (
      <ListGroup.Item as="li" bsPrefix=" ">
        <Dropdown
          alignRight={!rtlLayout}
          show={showNotification}
          onToggle={() => setShowNotification(!showNotification)}
        >
          <Dropdown.Toggle
            as={Link}
            variant="link"
            to="#"
            id="dropdown-basic"
            onClick={toggleNotification}
          >
            <i className="feather icon-bell icon" />
            {notification.length>0 && showBadge.notification === true && (
              <span className="badge badge-pill badge-danger">
                <span />
                {summaryNotification?.total || notification.length}
              </span>
            )}
          </Dropdown.Toggle>
          <Dropdown.Menu
            alignRight
            className="notification notification-scroll"
          >
            <div className="noti-head">
              <h6 className="d-inline-block m-b-0">Notifications</h6>
              <div className="float-right">
                <Link
                  to="#"
                  className="m-r-10"
                  onClick={(e) => {
                    e.preventDefault();
                    onMarkAsReadAll();
                  }}
                >
                  mark as read
                </Link>
                <Link
                  to="#"
                  onClick={(e) => {
                    e.preventDefault();
                    onDeleteAll();
                  }}
                >
                  clear all
                </Link>
              </div>
            </div>
            <PerfectScrollbar>
              <ListGroup
                as="ul"
                bsPrefix=" "
                variant="flush"
                className="noti-body"
              >
                {/* <ListGroup.Item as="li" bsPrefix=" " className="n-title">
                <p className="m-b-0">NEW</p>
              </ListGroup.Item>
              <ListGroup.Item as="li" bsPrefix=" " className="notification">
                <Media>
                  <img
                    className="img-radius"
                    src={avatar1}
                    alt="Generic placeholder"
                  />
                  <Media.Body>
                    <p>
                      <strong>John Doe</strong>
                      <span className="n-time text-muted">
                        <i className="icon feather icon-clock m-r-10" />
                        30 min
                      </span>
                    </p>
                    <p>New ticket Added</p>
                  </Media.Body>
                </Media>
              </ListGroup.Item>
              <ListGroup.Item as="li" bsPrefix=" " className="n-title">
                <p className="m-b-0">EARLIER</p>
              </ListGroup.Item> */}
                {notification.length == 0 && (
                  <ListGroup.Item as="li" bsPrefix=" " className="notification">
                    <Media>
                      <Media.Body>
                        <span>No Notifications...</span>
                      </Media.Body>
                    </Media>
                  </ListGroup.Item>
                )}
                {notification.map((item) => {
                  const { subject, message } = item;
                  const {actions} = message
                  const MAX_LEN = 120;

                  const text = message?.text || "";
                  const shortText =
                    text.length > MAX_LEN
                      ? text.slice(0, MAX_LEN) + "..."
                      : text;

                  return (
                    <ListGroup.Item
                      key={item.notificationId} // ✅ ใช้ id
                      as="li"
                      bsPrefix=" "
                      className="notification"
                      style={{ cursor: "pointer" }}
                      onClick={()=>{
                        if(actions && actions.length >0) history.push(actions[0].link)
                      }}
                    >
                      <Media>
                        <img
                          className="img-radius"
                          src={`${getBaseURL()}/media/attachment/thumbnail/${
                            item?.user?.profileAttachmentId
                          }`}
                          alt={item?.user?.firstName || "user"}
                          onError={(e) => {
                            e.currentTarget.onerror = null;
                            e.currentTarget.src = fallbackImage;
                          }}
                        />

                        <Media.Body>
                          <p>
                            <strong>
                              {item?.user?.prefix?.name}
                              {item?.user?.firstName}
                            </strong>
                            <span className="n-time text-muted">
                              <i className="icon feather icon-clock m-r-10" />
                              {timeAgo(item.createdAt)}
                            </span>
                          </p>

                          <p>{subject}</p>

                          {/* ✅ short message preview */}
                          <p className="text-muted">{shortText}</p>
                        </Media.Body>
                      </Media>
                    </ListGroup.Item>
                  );
                })}
                {
                  notification.length !=0 && notification.length !== summaryNotification?.total && (
                  <ListGroup.Item as="li" bsPrefix=" " className="notification">
                    <Media>
                      <Media.Body>
                        <Link to="/users/notification"><i className="feather icon-bell icon mr-1" /><span> ยังมีข้อความอีก เปิดดู...</span></Link>
                      </Media.Body>
                    </Media>
                  </ListGroup.Item>
                    
                  )
                }
              </ListGroup>
            </PerfectScrollbar>
            <div className="noti-footer">
              <Link to="/users/notification">show all</Link>
            </div>
          </Dropdown.Menu>
        </Dropdown>
      </ListGroup.Item>
    );
  };

  const renderFeedNotification = () => {
    return (
      <>
        {showFeedModal === true && (
          <Modal
            show={showFeedModal}
            onHide={() => setShowFeedModal(false)}
            size="lg"
            backdrop="static"
            keyboard={false}
          >
            <Modal.Header closeButton onHide={() => setShowFeedModal(false)}>
              <Modal.Title>📢 แจ้งเตือนระบบรายวัน</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {feedList.map((item, idx) => {
                const user = item?.feed?.createdByUser;
                return (
                  <div className="card hd-body">
                    <div className="row align-items-center">
                      <div className="col border-right pr-0">
                        <div key={idx} className="card-body inner-center">
                          <div className="ticket-customer font-weight-bold">
                            <i className="feather icon-user mr-1 f-14 text-c-blue" />
                            {user?.prefix?.name}
                            {user.firstName} {user.lastName}
                            <i className="feather icon-bell ml-1 mr-1 f-14 text-c-red" />
                            {item.feed.title}
                          </div>
                          <div>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: DOMPurify.sanitize(
                                  item.feed.description || ""
                                ),
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </Modal.Body>
            <Modal.Footer>
              <Button variant="info" onClick={onAckClick}>
                👍 รับทราบ!
              </Button>
            </Modal.Footer>
          </Modal>
        )}
      </>
    );
  };

  const onMarkAsRead = async (notificationId)=>{      

      try{
          await httpClient.put(`/workspace/notification/me?notificationId=${notificationId}`,{                
              isRead:1
          })

      } catch (e) {
          
          
      }
  }

  const renderNotificationFirstOfTheDay = () => {
    return (
      <>
        {showNotificationModal === true && (
          <Modal
            show={showNotificationModal}
            onHide={() => setShowNotificationModal(false)}
            size="lg"
            scrollable
            backdrop="static"
            keyboard={false}
          >
            <Modal.Header closeButton onHide={() => setShowNotificationModal(false)}>
              <Modal.Title>📢 แจ้งเตือน Notification</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {notification.map((item, idx) => {
                const user = item?.createdByUser;
                const {notificationId} = item
                const {actions} = item?.message || []
                return (
                  <div className="card hd-body">
                    <div className="row align-items-center">
                      <div className="col border-right pr-0">
                        <div key={idx} className="card-body inner-center">
                          <div className="ticket-customer font-weight-bold">
                            <i className="feather icon-user mr-1 f-14 text-c-blue" />
                            {user?.prefix?.name}
                            {user?.firstName} {user?.lastName}
                            <i className="feather icon-bell ml-1 mr-1 f-14 text-c-red" />
                            {item.subject}
                          </div>
                          <div>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: DOMPurify.sanitize(
                                  item?.message?.text || ""
                                ),
                              }}
                            />
                            {
                                actions && actions.length > 0 && (                        
                                        <React.Fragment>
                                            <hr />
                                            <div className="d-flex justify-content-start">
                                            {actions.map((action,index)=>(
                                                <Button
                                                    key={index}
                                                    onClick={async () => {
                                                        await onMarkAsRead(notificationId,0)
                                                        onAckNotificationClick()
                                                        if (action?.link) history.push(action.link)   
                                                          
                                                        setShowNotificationModal(false)
                                                    }}
                                                    variant="primary"
                                                    >
                                                    {action.label}
                                                </Button>
                                            ))
                                            }
                                            </div>
                                        </React.Fragment>                            
                                    )                    
                            }  
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </Modal.Body>
            <Modal.Footer>
              <Button variant="info" onClick={onViewNotification}>
                🔍 กดเข้าไปดูทั้งหมด {summaryNotification?.total} รายการ
              </Button>
              <Button variant="outline-dark" onClick={onAckNotificationClick}>
                👍 ไม่แสดงอีกในวันนี้ 
              </Button>
            </Modal.Footer>
          </Modal>
        )}
      </>
    );
  };

  return (
    <React.Fragment>
      <ListGroup as="ul" bsPrefix=" " className="navbar-nav ml-auto">
        {renderAvailableApp()}
        {renderNotification()}
        <ListGroup.Item as="li" bsPrefix=" ">
          <Dropdown>
            <Dropdown.Toggle
              as={Link}
              variant="link"
              to="#"
              className="displayChatbox"
              onClick={(event) => {
                event.preventDefault();
                setListOpen(true);
              }}
            >
              <i className="icon feather icon-mail" />
              {showBadge.online === true && (
                <span className="badge bg-success">
                  <span />
                </span>
              )}
            </Dropdown.Toggle>
          </Dropdown>
        </ListGroup.Item>
        <ListGroup.Item as="li" bsPrefix=" ">
          <Dropdown>
            <Dropdown.Toggle
              as={Link}
              variant="link"
              to="#"
              className="displayChatbox"
              onClick={openTaskBoard}
            >
              <i className="fa fa-tasks" />
              {showBadge.task === true && (
                <span className="badge bg-warning">
                  <span />
                </span>
              )}
            </Dropdown.Toggle>
          </Dropdown>
        </ListGroup.Item>
        <ListGroup.Item as="li" bsPrefix=" ">
          <Dropdown
            alignRight={!rtlLayout}
            className="drp-user"
            show={showDropdown}
            onToggle={() => setShowDropdown(!showDropdown)}
          >
            <Dropdown.Toggle
              as={Link}
              variant="link"
              to="#"
              id="dropdown-basic"
              onClick={toggleDropdown}
            >
              <img
                src={`${getBaseURL()}/media/attachment/thumbnail/${
                  user.profileAttachmentId
                }`}
                className="img-radius wid-40"
                alt={user.nickname}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = fallbackImage;
                }}
              />
              {/* <Avatar src={`${getBaseURL()}/media/attachment/thumbnail/${user.profileAttachmentId}`} alt={user.nickname} sx={{width:'40px',height:'40px'}}
               style={{ width: '40px', height: '40px', borderRadius: '50%' }} 
               /> */}
            </Dropdown.Toggle>
            <Dropdown.Menu alignRight className="profile-notification">
              <div className="pro-head">
                <div className="pro-head-content">
                  <img
                    src={`${getBaseURL()}/media/attachment/thumbnail/${
                      user.profileAttachmentId
                    }`}
                    className="img-radius wid-40"
                    alt={user.nickname}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = fallbackImage;
                    }}
                  />
                  <div className="pro-head-text">
                    <span>{user.displayName}</span>
                    <span>G : {user.groups[0] || "No Group"}</span>
                    <span>P : {user.positionName || "..."}</span>
                    <span>R : {user.employeeRoleCode || "..."}</span>
                  </div>
                </div>
                <Link
                  to="#"
                  className="dud-logout"
                  title="Logout"
                  onClick={handleLogout}
                >
                  <i className="feather icon-log-out" />
                </Link>
              </div>

              <ListGroup
                as="ul"
                bsPrefix=" "
                variant="flush"
                className="pro-body"
              >
                {userMenu.map(
                  (
                    {
                      title,
                      path,
                      icon,
                      iconSource,
                      iconName,
                      iconText,
                      iconType,
                      iconColor,
                      iconTextColor,
                    },
                    index
                  ) => (
                    <ListGroup.Item
                      as="li"
                      bsPrefix=" "
                      key={`user-menu-${index}`}
                    >
                      <Link to="#" className="dropdown-item" onClick={(event)=>onClickMenu(event,path)}>
                        {iconType === "icon" && iconSource === "ckd" && (
                          <span style={{ display: "contents" }}>
                            <i
                              className={`ckd-icon ckd-${icon} ml-1 mr-2`}
                              style={{
                                color: iconColor,
                                margin: 0,
                                fontSize: "18px",
                              }}
                            ></i>
                          </span>
                        )}
                        {iconType === "icon" && iconSource === "feather" && (
                          <span
                            style={{
                              width: "30px",
                              display: "inline-flex",
                            }}
                          >
                            <FeatherIcon
                              style={{ color: iconColor }}
                              icon={icon}
                              size="18"
                            />
                          </span>
                        )}
                        {iconType === "icon" && iconSource === "fas" && (
                          <span
                            style={{
                              width: "30px",
                              display: "inline-flex",
                              alignItems: "center",
                            }}
                          >
                            <i
                              className={`fas fa-${icon} mx-1`}
                              style={{
                                color: iconColor,
                                fontSize: "16px",
                              }}
                            />
                            {iconText ? iconText : ""}
                          </span>
                        )}
                        {iconType === "icon" && iconSource === "healthicons" && (
                          <span
                            style={{
                              width: "30px",
                              display: "inline-flex",
                              alignItems: "center",
                            }}
                          >
                            <i
                              className={`healthicons-${icon}-outline`}
                              style={{ color: iconColor, fontSize: "24px" }}
                            ></i>
                          </span>
                        )}
                        {title}
                      </Link>
                    </ListGroup.Item>
                  )
                )}
                <ListGroup.Item as="li" bsPrefix=" ">
                  <Link to="#" className="dropdown-item" onClick={handleLogout}>
                    <i className="feather icon-log-out" /> Logout
                  </Link>
                </ListGroup.Item>
              </ListGroup>
            </Dropdown.Menu>
          </Dropdown>
        </ListGroup.Item>
      </ListGroup>
      <ChatList listOpen={listOpen} closed={() => setListOpen(false)} />
      {showAudioAnalyzerFloatingMenu && <AudioAnalyzerFloatingMenu />}
      {showPatientQueueFloatingMenu && <PatientQueueFloatingMenu />}
      {renderFeedNotification()}
      {renderNotificationFirstOfTheDay()}
      <ToastProvider
        placement="bottom-right"
        newestOnTop={true}
        _components={{ Toast: AlertMessage }}
      >
        <NotificationToast />
        <NotificationSubscribeToast webSubscription={webSubscription} />
      </ToastProvider>
    </React.Fragment>
  );
};

export default NavRight;
